import { store } from "../../index";
import { logoutUser } from "../../redux/actions/loginActions";

export const handleUserLogout = (history) => {
  store.dispatch(logoutUser(history));
};